
const SolutionsSection = () => {
  const solutions = [
    {
      number: '01',
      title: 'Secrétariat Médical & Juridique',
      description: 'Bénéficiez d\'un secrétariat professionnel dédié à votre activité. Gestion des appels, prise de rendez-vous, accueil téléphonique, suivi des dossiers : une assistance complète qui s\'adapte à vos horaires et à vos besoins spécifiques.',
      benefits: [
        'Accueil téléphonique personnalisé',
        'Gestion d\'agenda optimisée',
        'Suivi des dossiers patients/clients',
        'Disponibilité étendue',
      ],
      image: 'https://public.readdy.ai/ai/img_res/5b1bf30e43f41721e71d2c6bcfdd26b4.jpg',
    },
    {
      number: '02',
      title: 'Assistance Directionnelle',
      description: 'Déléguez la gestion de votre cabinet à une assistante qualifiée. Coordination des équipes, gestion des fournisseurs, suivi comptable et administratif : concentrez-vous sur votre expertise pendant qu\'on s\'occupe du reste.',
      benefits: [
        'Coordination d\'équipe',
        'Gestion des fournisseurs',
        'Suivi comptable et facturation',
        'Organisation administrative',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20executive%20assistant%20managing%20office%20operations%20with%20laptop%20and%20documents%20in%20modern%20professional%20practice%2C%20organized%20workspace%20showing%20administrative%20efficiency%2C%20bright%20contemporary%20office%20environment%2C%20high%20quality%20business%20photography%20style&width=800&height=600&seq=liberal-assistance-001&orientation=landscape',
    },
    {
      number: '03',
      title: 'Recrutement Spécialisé',
      description: 'Trouvez les bons profils pour votre cabinet avec un accompagnement personnalisé. De la définition du poste à l\'intégration, nous vous aidons à recruter des collaborateurs qualifiés qui partagent vos valeurs professionnelles.',
      benefits: [
        'Sourcing de candidats qualifiés',
        'Présélection et entretiens',
        'Vérification des références',
        'Accompagnement à l\'intégration',
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20job%20interview%20in%20modern%20medical%20or%20legal%20office%2C%20recruiter%20meeting%20with%20qualified%20candidate%20in%20bright%20consultation%20room%2C%20professional%20hiring%20process%2C%20contemporary%20practice%20environment%2C%20high%20quality%20business%20photography&width=800&height=600&seq=liberal-recrutement-001&orientation=landscape',
    },
    {
      number: '04',
      title: 'Gestion Administrative Complète',
      description: 'Simplifiez votre quotidien avec une gestion administrative externalisée. Facturation, relances, déclarations, gestion des mutuelles et organismes : des experts prennent en charge toutes vos obligations administratives.',
      benefits: [
        'Facturation automatisée',
        'Gestion tiers-payant',
        'Déclarations obligatoires',
        'Suivi des impayés',
      ],
      image: 'https://readdy.ai/api/search-image?query=Organized%20professional%20office%20desk%20with%20laptop%20showing%20medical%20or%20legal%20billing%20software%2C%20invoices%20and%20administrative%20documents%20neatly%20arranged%2C%20modern%20professional%20workspace%20with%20efficient%20document%20management%2C%20natural%20lighting%2C%20high%20quality%20business%20photography&width=800&height=600&seq=liberal-admin-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour les Libéraux
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Des services adaptés aux spécificités de votre profession
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 text-6xl md:text-8xl font-bold text-primary-light/20 select-none">
                    {solution.number}
                  </div>
                  <div className="relative space-y-4 md:space-y-6">
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-primary-dark">
                      {solution.title}
                    </h3>
                    <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
                      {solution.description}
                    </p>
                    <ul className="space-y-2 md:space-y-3">
                      {solution.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-sm md:text-base text-gray-dark">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
